/*
 * Gift Exchange — gift & cloud parallax.
 *
 * The gift box and the two clouds drift with the pointer and gently shift as the
 * section scrolls through the viewport. Each layer has its own depth so the
 * clouds move more than the box, giving a sense of depth. Offsets are written to
 * CSS custom properties (--ge-px / --ge-py / --ge-sy) which the stylesheet folds
 * into each element's transform, so the existing centering is preserved. Purely
 * decorative: disabled when the user prefers reduced motion.
 */
function init() {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const scene = document.querySelector('.ge-gift');
  if (!scene || reduceMotion) return;

  // pointer: px of mouse parallax. driftX: px of horizontal scroll drift (clouds).
  // rotate: deg of scroll rotation (box).
  const layers = [
    { el: scene.querySelector('.ge-gift__box'), pointer: 8, driftX: 0, rotate: 5 },
    { el: scene.querySelector('.ge-gift__cloud--2'), pointer: 16, driftX: 40, rotate: 0 },
    { el: scene.querySelector('.ge-gift__cloud--1'), pointer: 26, driftX: -64, rotate: 0 },
  ].filter((layer) => layer.el);

  if (layers.length === 0) return;

  let pointerX = 0; // -1 .. 1
  let pointerY = 0; // -1 .. 1
  let scrollProgress = 0; // -1 .. 1
  let frame = 0;

  const apply = () => {
    frame = 0;
    layers.forEach(({ el, pointer, driftX, rotate }) => {
      el.style.setProperty('--ge-px', `${(pointerX * pointer).toFixed(1)}px`);
      el.style.setProperty('--ge-py', `${(pointerY * pointer).toFixed(1)}px`);
      el.style.setProperty('--ge-sx', `${(scrollProgress * driftX).toFixed(1)}px`);
      el.style.setProperty('--ge-rot', `${(scrollProgress * rotate).toFixed(2)}deg`);
    });
  };

  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(apply);
  };

  window.addEventListener(
    'pointermove',
    (event) => {
      if (event.pointerType === 'touch') return;
      const halfW = window.innerWidth / 2;
      const halfH = window.innerHeight / 2;
      pointerX = Math.max(-1, Math.min(1, (event.clientX - halfW) / halfW));
      pointerY = Math.max(-1, Math.min(1, (event.clientY - halfH) / halfH));
      schedule();
    },
    { passive: true }
  );

  const onScroll = () => {
    const rect = scene.getBoundingClientRect();
    const vh = window.innerHeight || document.documentElement.clientHeight;
    const center = rect.top + rect.height / 2;
    // -1 entering from the bottom, +1 leaving at the top.
    scrollProgress = Math.max(-1, Math.min(1, (center - vh / 2) / ((vh + rect.height) / 2)));
    schedule();
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  onScroll();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
